/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelComments.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/comments";

export class AutogenModelComments<RowType extends ModelRow> extends Endpoint<RowType, RowCommentsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowComments extends ModelRow<RowCommentsFields> {
	constructor(values?: Partial<RowCommentsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCommentsFields {
	attach_filename: string;
	attachment: string;
	comment_type_id: string;
	comments: string;
	company_id: string;
	copy_to_order: string;
	display_atdispatch: string;
	entered_date: Date;
	entered_user_id: string;
	id: string;
	onboard_lock: string;
	order_comment_type: string;
	parent_row_id: string;
	parent_row_type: string;
	rmis_image_id: string;
	user_name: string;
}

